const testimonials = [
  {
    name: 'Marcos Oliveira',
    role: 'Guitarrista — Igreja Batista Central',
    text: 'O Escala Equipe mudou completamente nosso ensaio. Antes era papel e WhatsApp, agora tudo sincronizado em tempo real. Incrível.',
    stars: 5,
  },
  {
    name: 'Ana Paula Ferreira',
    role: 'Líder de Louvor — Comunidade Vida',
    text: 'A transposição automática salvou nosso culto várias vezes. Cantor pediu tom diferente na hora — dois cliques e resolvido.',
    stars: 5,
  },
  {
    name: 'Rafael Costa',
    role: 'Baixista — Ministério Águas Vivas',
    text: 'O modo baixo com tônicas e notas de passagem é exatamente o que eu precisava. Finalmente uma ferramenta que pensa no baixista.',
    stars: 5,
  },
  {
    name: 'Pedro Alves',
    role: 'Baterista — Banda Shalom',
    text: 'Os botões de aviso ao vivo são geniais. Quando o líder aperta "somente bateria", todo mundo sabe na hora. Zero comunicação verbal.',
    stars: 5,
  },
  {
    name: 'Camila Santos',
    role: 'Vocalista — Ministério Ágape',
    text: 'Interface linda, leve e intuitiva. Nunca precisei de tutorial. Abri e já estava usando. Recomendo para qualquer ministério.',
    stars: 5,
  },
];

const TestimonialsSection = () => (
  <section className="bg-[#F5F0E8] py-28 px-6 md:px-10">
    <div className="max-w-7xl mx-auto">
      <div className="mb-14">
        <div className="flex items-center gap-3 mb-4">
          <span className="w-1.5 h-1.5 rounded-full bg-[#8B6F3E]"></span>
          <span className="text-[#8B6F3E] text-xs uppercase tracking-widest">Comunidade</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-light text-[#1A1510] leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
          Músicos que já<br />
          <strong>transformaram seu louvor.</strong>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {testimonials.map((t) => (
          <div
            key={t.name}
            className="bg-white rounded-2xl p-7 flex flex-col gap-4"
          >
            <div className="flex gap-1">
              {[...Array(t.stars)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#C8A96E] text-sm"></i>
              ))}
            </div>
            <p className="text-[#1A1510] text-sm leading-relaxed flex-1">&ldquo;{t.text}&rdquo;</p>
            <div className="flex items-center gap-3 pt-4 border-t border-[#F0EBE0]">
              <div className="w-9 h-9 rounded-full bg-[#C8A96E]/20 flex items-center justify-center">
                <i className="ri-user-line text-[#8B6F3E] text-sm"></i>
              </div>
              <div>
                <p className="text-[#1A1510] text-sm font-semibold">{t.name}</p>
                <p className="text-[#8B6F3E] text-xs">{t.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
